import { render, staticRenderFns } from "./ExternalView.vue?vue&type=template&id=6d4ef50a&scoped=true&"
import script from "./ExternalView.vue?vue&type=script&lang=js&"
export * from "./ExternalView.vue?vue&type=script&lang=js&"
import style0 from "./ExternalView.vue?vue&type=style&index=0&id=6d4ef50a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ef50a",
  null
  
)

export default component.exports